import {steps} from '../../../types/Stepper';

export const getStepFromLabel = (label: string): number =>
    steps.findIndex((step) => step.label === label) + 1;
